var classes = {
    CLOSE_BTN: "dcw_popin_modal_close-btn",
    POPIN_OVERLAY: "dcw_popin_modal_overlay",
    POPIN_CLOSE: "dcw_popin_close"
};

function PopinView(root, titleElement, descriptionElement) {
    var self = this;
	
	this.root = root;
    this.titleElement = titleElement;
    this.descriptionElement = descriptionElement;
	this.callingElement = null;
	this.readonly=false;

	// Handle mouse & keyboard events
	
	// - Mouse closeBtn
	this.onCloseButtonClick();
	
	//- Keydown (any key (esp. TAB (9))) : stopPropagation()
	this.root.addEventListener("keydown", function (e) {
		if (e.keyCode === 9 ) {
			e.stopPropagation(); e.preventDefault();
			
			// Go next/previous tabable element in modal
			// ! Pas testé
			let focusableElements = self.root.querySelectorAll('[tabindex]');
			if (focusableElements.length >1) {
				let newIndex=0;
				let currentIndex = focusableElements.indexOf(document.activeElement);
				if (currentIndex>=0) {
					if (e.shiftKey)
						newIndex = (currentIndex - 1 + focusableElements.length);
					else
						newIndex = (currentIndex + 1);
					newIndex = newIndex % focusableElements.length;
				}	
				focusableElements[newIndex].focus();
			}
		}
	});

	//- Keyup : stopPropagation(), 
	// - 'ESC' : hide()
	this.root.addEventListener("keyup", function (event) {
		if (event.keyCode === 27)
			self.hide();
	});			
	
}

PopinView.prototype.onCloseButtonClick = function () {
    var self = this;

    this.root.addEventListener("click", function (event) {
        if (event.target.classList.contains(classes.CLOSE_BTN) || event.target.classList.contains(classes.POPIN_OVERLAY) ||  event.target.classList.contains(classes.POPIN_CLOSE)) {
            self.hide();
        }
    });
};

PopinView.prototype.setTitleElement = function (titleElement) {
    this.titleElement = titleElement;
};

PopinView.prototype.setDescriptionElement = function (descriptionElement) {
    this.descriptionElement = descriptionElement;
};

PopinView.prototype.show = function () {
    this.root.style.display = "block";
    this.root.firstElementChild.style.display = "block";
	
	// Set focus on first button
	var closebtn = this.root.getElementsByTagName("button")[0];
	if (closebtn) 
		closebtn.focus();
	
};

PopinView.prototype.hide = function () {
    this.root.style.display = "none";

	if (this.callingElement)
		this.callingElement.focus();
};

PopinView.prototype.render = function (model) {
	
    if (this.titleElement) 
        this.titleElement.innerHTML = model.keyword;
    if (this.descriptionElement) 
        this.descriptionElement.innerHTML = model.definition;
	
	this.readonly = (this.callingElement && this.callingElement.getAttribute("readonly")=="true" );
	
};

export default PopinView;



// WEBPACK FOOTER //
// ./src/js/cms/commons/Popin/Popin.view.js